export default "__VITE_ASSET__b013e12e__"